import { Routes } from '@angular/router';
// Guard
import { AccessGuard } from '../_guards/access.guard';
import { AuthGuard } from '../_guards/auth.guard';
import { CommunityGuard } from '../_guards/community.guard';
import { ContextGuard } from '../_guards/context.guard';
import { DataGuard } from '../_guards/data.guard';
// Component imports
import { WorkflowEditorComponent } from '../workflow/components/workflow-editor/workflow-editor.component';
import { ManageWorkflowVendorEditComponent } from './components/manage-workflow-vendor-edit/manage-workflow-vendor-edit.component';
import { WorkflowQueueComponent } from './components/workflow-queue/workflow-queue.component';
import { WorkflowReimbursementRequestComponent } from './components/workflow-reimbursement-request/workflow-reimbursement-request.component';
import { WorkflowSearchComponent } from './components/workflow-search/workflow-search.component';
import { WorkflowSubmittedInvoicesComponent } from './components/workflow-submitted-invoices/workflow-submitted-invoices.component';
import { WorkflowUserMetricsComponent } from './components/workflow-user-metrics/workflow-user-metrics.component';
import { WorkflowVendorMissingBillsComponent } from './components/workflow-vendor-missing-bills/workflow-vendor-missing-bills.component';
import { WorkflowPaymentRequestComponent } from '../workflow-payment-request-module/components/workflow-payment-request/workflow-payment-request.component';
const ɵ0 = {
    anonymousAccess: false,
    newWindow: true,
    resizable: false,
    outletOnly: true,
    title: 'AAP Workflow Invoices',
    accessCode: 'SEARCH_INVOICES'
};
const childRoutes = [
    {
        path: 'managevendoredit',
        component: ManageWorkflowVendorEditComponent,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'searchinvoices',
        component: WorkflowSearchComponent,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'vendormissingbills',
        component: WorkflowVendorMissingBillsComponent,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'reimbursementrequest',
        component: WorkflowReimbursementRequestComponent,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'paymentrequest',
        component: WorkflowPaymentRequestComponent,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'wfinvoices',
        component: WorkflowSearchComponent,
        canActivate: [AuthGuard, AccessGuard, DataGuard],
        data: ɵ0
    },
    {
        path: 'submittedinvoices',
        component: WorkflowSubmittedInvoicesComponent,
        canActivate: [AuthGuard, AccessGuard]
    }
];
const ɵ1 = { accessCode: 'WORKQUEUE' }, ɵ2 = {
    anonymousAccess: false,
    newWindow: true,
    resizable: false,
    outletOnly: true,
    title: 'Workflow'
};
const workflowRoutes = [
    {
        path: '',
        children: [
            ...childRoutes,
            {
                path: 'workqueue',
                component: WorkflowQueueComponent,
                canActivate: [AuthGuard, AccessGuard]
            },
            {
                path: ':work/:status/workqueue',
                data: ɵ1,
                component: WorkflowQueueComponent,
                canActivate: [AuthGuard, AccessGuard]
            },
            {
                path: 'editor',
                component: WorkflowEditorComponent,
                canActivate: [AuthGuard, AccessGuard]
            },
            {
                path: 'workflow-editor',
                component: WorkflowEditorComponent,
                canActivate: [AuthGuard, DataGuard],
                data: ɵ2
            },
            {
                path: 'metrics',
                component: WorkflowUserMetricsComponent,
                canActivate: [AuthGuard, AccessGuard]
            },
            {
                path: ':communityId',
                canActivate: [AuthGuard, CommunityGuard, ContextGuard],
                children: childRoutes
            },
            { path: '**', redirectTo: 'workqueue' }
        ]
    },
    { path: '**', pathMatch: 'full', redirectTo: '/home' }
];
export class WorkflowRoutingModule {
}
export { ɵ0, ɵ1, ɵ2 };
